import Model from "~/models/_Model";
import dayjs from "dayjs";

export default class ComparisonAssignment extends Model {
  // Define a base url for a REST API
  baseURL() {
    return super.baseURL() + "/schoology";
  }

  // Set the resource route of the model
  resource() {
    return "comparisons/assignments";
  }

  get sort_key() {
    return "";
    //return `${this.display_marking_periods}-${this.period}-${this.display_name}`;
  }

  get public_fields() {
    const extra_credit_map = {
      N: "N",
      T: "T",
    };
    return [
      {
        name: "DESCRIPTION",
        label: "Name",
        format: (val) => val,
      },
      {
        name: "CATEGORY",
        label: "Category",
        format: (val) => val,
      },
      {
        name: "DESC_DETAIL",
        label: "Description",
        format: (val) => val,
      },
      {
        name: "DUE_DATE",
        label: "Due Date",
        format: (val) => (val ? dayjs(val).format("MM/DD/YYYY") : null),
      },
      {
        name: "POINTS",
        label: "Points",
        format: (val) => val,
      },
      {
        name: "WEIGHT",
        label: "Weight",
        format: (val) => val,
      },
      {
        name: "EXTRA_CREDIT",
        label: "Extra Credit",
        format: (val) => extra_credit_map[val] || val,
      },
      {
        name: "CANNOT_DROP",
        label: "Cannot Drop",
        format: (val) => val,
      },
      {
        name: "PUBLISH_ASMT",
        label: "Publish Assignment",
        format: (val) => val,
      },
      {
        name: "PUBLISH_SCORES",
        label: "Publish Scores",
        format: (val) => val,
      },
      /*
      {
        name: "CHANGE_UID",
        label: "Change By",
        format: (val) => val,
      },
      */
      {
        name: "ASMT_NUMBER",
        label: "Internal Asmt ID",
        format: (val) => val,
      },
    ];
  }

  getResultCount(resultType = null) {
    if (resultType) {
      return this.results[resultType].length;
    }
    let count = 0;
    Object.values(this.results).forEach(
      (subResult) => (count += subResult.length)
    );
    return count;
  }
}
